import React, { useState } from 'react';

export function NewsletterFooter() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    try {
      setIsSubmitting(true);
      setError('');
      
      const response = await fetch('https://api.solvy.com/v1/newsletter/footer-signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error('Newsletter signup failed');
      }

      setEmail('');
    } catch (err) {
      setError('Failed to sign up. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="tw-relative tw-flex tw-flex-col tw-w-full tw-text-lg tw-p-0">
      <div className="tw-relative tw-flex tw-justify-between tw-items-center tw-bg-dark-green tw-px-20 tw-py-24">
        <div className="tw-flex tw-items-center tw-gap-10">
          <img
            src="https://expertpeople.imgix.net/assets/images/solvy-logo-white.png"
            alt="Solvy"
            className="tw-object-contain"
            style={{width: "130px", aspectRatio: "1.86"}}
          />
          <a 
            href="mailto:info@solvy.com" 
            className="hover:tw-underline"
            aria-label="Email us at info@solvy.com"
          >
            info@solvy.com
          </a>
        </div>

        <form
          onSubmit={handleSubmit}
          className="tw-hidden tw-flex tw-items-center tw-bg-gray-800 tw-rounded-lg"
          aria-label="Newsletter signup"
        >
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="tw-px-8 tw-py-4 tw-bg-transparent tw-text-white tw-placeholder-white"
            required
            aria-label="Email address for newsletter"
            disabled={isSubmitting}
          />
          <button
            type="submit"
            className="tw-p-4 tw-bg-white tw-rounded-lg"
            disabled={isSubmitting}
            aria-label="Subscribe to newsletter"
          >
            <img
              src="https://cdn.builder.io/o/assets/arrow-right-9135.svg"
              alt=""
              className="tw-w-8 tw-h-8"
              aria-hidden="true"
            />
          </button>
        </form>
      </div>

      {error && (
        <div role="alert" className="tw-relative tw-mt-2 tw-text-red-500">
          {error}
        </div>
      )}

      <p className="tw-hidden tw-relative tw-mt-4 tw-text-right tw-mr-56">
        * New subscribers get $5 credit
      </p>

      <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-text-lg tw-font-medium tw-px-20 tw-py-24 tw-pb-16">
        <p>
          Copyright 2025 — All rights reserved
        </p>
        <div className="tw-flex tw-gap-10 tw-justify-center">
          <a 
            href="/information?selected=privacy_policy" 
            target='_blank'
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}
